export default "__VITE_ASSET__00429cff__"